import React from "react";
import { number, string, bool } from "prop-types";
import { motion } from "framer-motion";

const ProgressCircle = ({
  size = 50,
  delay = 0.3,
  fillDuration = 0.3,
  drawDuration = 0.3,
  progressBarColor = "#000",
  isComplete = false,
}) => (
  <motion.svg
    width={size}
    height={size}
    viewBox="0 0 68 68"
    xmlns="http://www.w3.org/2000/svg"
    initial={{ fill: "#FFF" }}
    animate={{ fill: isComplete ? progressBarColor : "#FFF" }}
    transition={{ delay: delay + drawDuration, duration: fillDuration }}
    transform="rotate(90)"
  >
    <motion.path
      d="M67 34C67 52.2254 52.2254 67 34 67C15.7746 67 1 52.2254 1 34C1 15.7746 15.7746 1 34 1C52.2254 1 67 15.7746 67 34Z"
      stroke={progressBarColor}
      strokeWidth="2"
      initial={{ pathLength: 0, opacity: isComplete ? 1 : 0.4 }}
      animate={{ pathLength: 1, opacity: isComplete ? 1 : 0.4 }}
      transition={{ delay: delay, duration: drawDuration }}
    />
  </motion.svg>
);

ProgressCircle.propTypes = {
  delay: number,
  drawDuration: number,
  fillDuration: number,
  size: number,
  progressBarColor: string,
  isComplete: bool,
};

export default ProgressCircle;
